export class WebhookV1StandardPayloadCloudAccountArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudAccountArguments",
            "baseName": "cloudAccountArguments",
            "type": "WebhookV1CloudAccountArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadCloudAccountArguments.attributeTypeMap;
    }
    constructor() {
    }
}
